import styled from 'styled-components';

const StyledSignInLoginButtonPartialWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-left: 505px;
  gap: 130px;
`;

export default StyledSignInLoginButtonPartialWrapper;
